import { Paper } from '@mui/material';
import { Player } from 'video-react';

const Styles = {
    paper: {
        maxWidth: { xl: 1240, lg: 940, md: 640, sm: 480, xs: 320 },
        width: { xl: 1200, lg: 900, md: 600, sm: 480, xs: 320 },
        margin: '20px auto',
        overflow: 'hidden',
        background: '#ededed'
    }
};

function DiscoverPage() {

    return (
        <Paper sx={Styles.paper}>
            <Player
                autoPlay
                src={`${process.env.PUBLIC_URL}/media/DiscoverPensieve.mp4`}
            />
        </Paper>
    )
}

export default DiscoverPage